// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"189":"91d7b01e52fce62d","190":"7427f132585b754b","420":"3e3a515540ee8468","443":"1851e946412ff103","612":"57c72869272bb0d9","939":"7c5b7a4c6d1203a9"}[chunkId] + ".js";
};